/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React, {FC} from 'react';
import {Grid} from '@material-ui/core';
import {Setter} from '../../components/daterangepicker/types';
import Month from './Month';

// defines the prop definitions for the component
export interface RenderDatePickerProps {
  date: Date;
  setDate: Setter<Date>;
  isDate?: boolean;
  isTime?: boolean;
  isDateTime?: boolean;
  manualInput?: string;
  allowManualEntry?: boolean;
  handleClickAway: (val?: React.MouseEvent<HTMLElement>) => void;
  handlers: {
    onDayClick: (day: Date, hours: number, minutes: number) => void;
    onDayHover: (day: Date) => void;
    onMonthNavigate: (action: number) => void;
    onYearNavigate: (action: number) => void;
    onInputChange?: Function;
    onChangeDate?: Function;
  };
  hideClearButton: boolean
}

/**
 * @RenderDatePicker
 *
 * Defines the RenderDatePicker component.
 */
export const RenderDatePicker: FC<RenderDatePickerProps> = ({
  date,
  setDate,
  handlers,
  isDate,
  isTime,
  isDateTime,
  allowManualEntry,
  manualInput,
  handleClickAway,
  hideClearButton = false
}: RenderDatePickerProps) => {
  const commonProps = {
    handlers
  };
  return (
    <div>
      <Grid container direction='row' wrap='nowrap'>
        <Month {...commonProps}
          value={date}
          isDate={isDate}
          isDateTime={isDateTime}
          isTime={isTime}
          manualInput={manualInput}
          allowManualEntry={allowManualEntry}
          handleClickAway={handleClickAway}
          setValue={setDate}
          hideClearButton={hideClearButton}/>
      </Grid>
    </div>
  );
};

export default RenderDatePicker;
